;"use strict";

let global_script = {
    _getGeoCountry: function (){

        /*let get_country = "";

        $.get("https://ipinfo.io", function(response) {
            //console.log(response.city, response.country);
            get_country = response.country;
            localStorage.setItem('localization-geo--country', get_country);
            if(get_country && localStorage.getItem('localization-geo--country') !== get_country){
                localStorage.removeItem("localization-geo--country");
                let change_link__currency = $("#AnnouncementCountryList a[data-value="+get_country+"] .localization-form__currency");
                if(change_link__currency.length){
                    change_link__currency.trigger("click");
                }
            }
        }, "jsonp");*/

        /*fetch('https://api.ipregistry.co/?key=tryout')
            .then(function (response) {
                return response.json();
            })
            .then(function (payload) {
                console.log(payload.location.country.code);
            });*/

    },
    _init: function (){
        this._getGeoCountry();
    }
}


let PDP_actions = {
    _anchor_reviews: function (){
        setTimeout(function (){
            let page = $("html, body");
            if($(location.hash).length){
                page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
                    page.stop();
                });

                page.animate({ scrollTop: $(location.hash).position().top - ($("sticky-header.c-header-wrapper").height()*1.5) }, 'slow', function(){
                    page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
                });
            }
        }, 200);
    },
    _similar_products: function (){
        $("[data-option--name]").each(function (i, elem) {
            if ($(elem).attr('data-option--name').indexOf("color") > -1 ||
                $(elem).attr('data-option--name').indexOf("Color") > -1 ||
                $(elem).attr('data-option--name').indexOf("couleur") > -1 ||
                $(elem).attr('data-option--name').indexOf("Couleur") > -1) {

                // 'trigger' ===>>> set image PDP gallery by 'color' variant after load page
                $(this).find('[type="radio"]:checked').next("label").trigger("click");

                // set current color PDP for parent block '.similar_products' after load page & 'click' on label 'color'
                $(".similar_products").attr("data-main-color", $(this).find(".current-value-variant").text().trim());

                // set label 'color' name PDP after load PDP
                //$(".similar_products__label span").text($(this).find(".current-value-variant").text().trim());
            }
        });

        // show active links in '.similar_products' by 'Color' after load PDP
        $('[data-color--link]').each(function (i, elem){
            if($(elem).attr('data-color--link').indexOf($("[data-main-color]").attr('data-main-color').trim()) > -1){
                $(elem).addClass("active");
            }
        });

        $("[data-option--name]").each(function (i, elem){
            if($(elem).attr('data-option--name').indexOf("color") > -1 ||
                $(elem).attr('data-option--name').indexOf("Color") > -1 ||
                $(elem).attr('data-option--name').indexOf("couleur") > -1 ||
                $(elem).attr('data-option--name').indexOf("Couleur") > -1){
                $(this).find("label").on("click", function (e){
                    let _this = $(this);
                    setTimeout(function (){
                        console.log(_this.attr("data-value"));
                    }, 200);
                    $(".similar_products__item_link").removeClass("active");
                    $(".similar_products__item").each(function (j, element){
                        $(element).find("a[data-color--link="+_this.attr("data-value")+"]").addClass("active");
                    });

                    // set color to '.similar_products' by 'click'
                    $(".similar_products").attr("data-main-color", _this.attr("data-value"));

                    // set label 'color' name PDP by 'click' on label 'color'
                    //$(".similar_products__label span").text($(this).parent().find(".current-value-variant").text().trim());
                });
            }
        });

        // get 'current' class for '.similar_products__item' by load PDP
        $(".similar_products__item_link").each(function (i, elem){
            if (window.location.href.indexOf($(elem).attr("href")) > -1) {
                $(elem).parent().addClass("current");
            }
        });

        // set label 'name' name PDP after load PDP
        setTimeout(function (){
            $(".similar_products__label span").text($("[data-name].current").attr("data-name").trim());
        }, 200);

        let dataNameLabel = $("[data-name].current").attr("data-name").trim();

        // hover product names
        $(document).on({
            mouseenter: function () {
                //stuff to do on mouse enter
                $(".similar_products__label span").text($(this).attr("data-name"));
            },
            mouseleave: function () {
                //stuff to do on mouse leave
                $(".similar_products__label span").text(dataNameLabel);
            }
        }, ".similar_products__item");
    },
    _moveWidgets: function (){

    },
    _scrollTopWindowPDPByLoad: function (){
        setTimeout(function (){
            window.onbeforeunload = function () {
                window.scrollTo(0, 0);
            }
        }, 400);
    },
    _init: function (){
        this._anchor_reviews();
        this._similar_products();
        //this._moveWidgets();
    }
}

$(window).on("load", function (){

    //global_script._init();

/*


    $.get("https://ipinfo.io", function(response) {
        //console.log(response.city, response.country);
        $('body').attr("data-country", response.country);
    }, "jsonp");
*/


    if($("body").attr("class").indexOf('product') > -1) {
        PDP_actions._init();
        if($(window).width() <= 991){
            $(window).scrollTop(0);
        }

        if($(".scrollingWidget--active").length){
            $("#move_widget").html("" +
                "html body #provesrc-widget-area #provesrc-notification-container{" +
                "bottom: 70px !important;" +
                "left: "+ $('.scrollingWidget').offset().left + "px" +
                "}" +
                "@media(min-width: 815px){" +
                "html body #provesrc-widget-area #provesrc-notification-container{" +
                "bottom: 120px!important;" +
                "left: "+ $('.scrollingWidget').offset().left + "px" +
                "}" +
                "}");
        }else{
            $("#move_widget").html("" +
                "html body #provesrc-widget-area #provesrc-notification-container{" +
                "left: "+ $('.scrollingWidget').offset().left + "px" +
                "}" +
                "@media(min-width: 815px){" +
                "html body #provesrc-widget-area #provesrc-notification-container{" +
                "left: "+ $('.scrollingWidget').offset().left + "px" +
                "}" +
                "}");
        }
        setTimeout(function () {
            $(window).trigger("resize");
            $(window).trigger("scroll");
        }, 200);
        $(window).on("scroll resize", function (){
            setTimeout(function (){
                if($(".scrollingWidget--active").length){
                    $("#move_widget").html("" +
                        "html body #provesrc-widget-area #provesrc-notification-container{" +
                        "bottom: 70px !important;" +
                        "left: "+ $('.scrollingWidget').offset().left + "px" +
                        "}" +
                        "@media(min-width: 815px){" +
                        "html body #provesrc-widget-area #provesrc-notification-container{" +
                        "bottom: 120px!important;" +
                        "left: "+ $('.scrollingWidget').offset().left + "px" +
                        "}" +
                        "}");
                }else{
                    $("#move_widget").html("" +
                        "html body #provesrc-widget-area #provesrc-notification-container{" +
                        "left: "+ $('.scrollingWidget').offset().left + "px" +
                        "}" +
                        "@media(min-width: 815px){" +
                        "html body #provesrc-widget-area #provesrc-notification-container{" +
                        "left: "+ $('.scrollingWidget').offset().left + "px" +
                        "}" +
                        "}");
                }
            }, 300);
        });

    }

});